module.exports = __webpack_public_path__ + "img/cookie_consent.dae48e50.jpg";